/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import React from 'react';
import { connect } from 'react-redux';
import { Form, InputGroup, FormControl, Button } from 'react-bootstrap';
import { EstateSaleMenuList } from '../EstateSales/EstateSaleMenuList';
import DatePicker from "react-datepicker";
import store from 'features/store';
import { CategoryService, CityAndStateService, LocationService } from 'shared/services';
import moment from 'moment';

import "react-datepicker/dist/react-datepicker.css";
import { ArrayValueReorder } from 'shared/modifiers';
import { advanceSearchMain, convertToMaintainData, disablePreviousState, getMaintainData, previousState } from 'shared/settings/stateMaintain';
import { addDataLayer, bannerImage } from 'shared/utils/utils';
import { CATERGORY } from 'shared/settings/config';

import './AdvanceSearch.scss';
import { Helmet } from 'react-helmet';
/**


@Author Karthik

@param

@return html code for Advance search

**/

class AdvanceSearch extends React.Component {
    constructor(props) {
        super(props);

        this.sideNavbar = null;
        this.searchForm = {
            location: { value: 'All', error: '', validators: [] },
            category: { value: 'All Categories', error: '', validators: [] },
            keywords: { value: '', error: '', validators: [] },
            includeDescription: { value: false, error: '', validators: [] },

            // Items location
            zipcode: { value: '', error: '', validators: [] },
            state: { value: '', error: '', validators: [] },
            country: { value: '', error: '', validators: [] },
            miles: { value: '', error: '', validators: [] },

            // Price range
            pricemin: { value: '', error: '', validators: [] },
            pricemax: { value: '', error: '', validators: [] },

            // Date
            startDate: { value: '', error: '', validators: [] },
            endDate: { value: '', error: '', validators: [] },

            // Search only
            auction: { value: false, error: '', validators: [] },
            directBuy: { value: false, error: '', validators: [] },
            onSite: { value: false, error: '', validators: [] },
            completed: { value: false, error: '', validators: [] },
            include: { value: false, error: '', validators: [] },
            buynow: { value: false, error: '', validators: [] },
            noreserve: { value: false, error: '', validators: [] },
            pictureOnly: { value: false, error: '', validators: [] },
            isshippable: { value: false, error: '', validators: [] },
            pickuponly: { value:false, error: '', validators: [] },

            // Sortby
            sortBy: { value: 'itemclosetime#*#asc#*#Listing Ending First', error: '', validators: [] },
        };
        this.state = {

            /* Sidemenu links */
            menuList: EstateSaleMenuList(),

            /* To handle responsive */
            innerWidth: window.innerWidth,
            pageLoading: true,
            locationList: [],
            categoryList: [],
            stateList: [],
            cityList: [],
            searchForm: Object.assign({}, this.searchForm),
            activeMenu: 'ALL',
            sideBarScrollHeight: 15,
            activeMenuStatus: false,
            activeMenuValue: '',
            activeSubMenuStatus: false,
            activeSubMenuValue: '',
            restrictedItems: false
        }
    }

    componentDidMount() {
        window.onload = () => {
            this.windowWidthGet();
        };
        window.addEventListener('resize', this.windowWidthGet);
        window.addEventListener('click', this.handleClickOutside);
        store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: "AdvancedSearch" } });
        this.checkPreviousValue();
    }

    componentDidUpdate(prevProps) {
        window.addEventListener('resize', this.windowWidthGet);
        if (JSON.stringify(prevProps.user) !== JSON.stringify(this.props.user)) {
            this.windowWidthGet();
        }
    }

    getTopLayout = () => {
        /* Getting required elements */
        const covidBannerCheck = document.getElementsByClassName('covid-banner');
        const covidBanner = covidBannerCheck.length > 0 ? covidBannerCheck[0].getBoundingClientRect().height : 0;
        const topLayout = document.getElementsByClassName('top-layout')[0] ? document.getElementsByClassName('top-layout')[0].getBoundingClientRect().height : 0;
        const mobileBanner = document.getElementById('mobile-banner') ? document.getElementById('mobile-banner').getBoundingClientRect().height : 0;
        this.setState({
            sideBarScrollHeight: covidBanner + topLayout + mobileBanner
        });
    }

    /* Called when resize the screen */
    windowWidthGet = () => {

        this.getTopLayout();

        this.setState({
            innerWidth: window.innerWidth
        }, () => {
            if (this.state.innerWidth < 1100) {
                store.dispatch({ type: 'SET_CUSTOM_SIDEBAR', payload: { icon: false, open: false } });
            } else if (this.state.innerWidth > 1100) {
                store.dispatch({ type: 'SET_CUSTOM_SIDEBAR', payload: { icon: false, open: false } });
            }
        });
    }

    checkPreviousValue = () => {
        const previous = getMaintainData(previousState);
        if (previous && previous.apply) {
            this.getPreviousValues();
        } else {
            this.getRequiredData();
        }
    }

    getRequiredData = () => {
        const postData = {
            "sort": [{ "field": "title", "direction": "asc" }],
            "field": ["id", "title"]
        };
        LocationService.getLocationList(postData).then(
            list => {

                CategoryService.getCategorySelectionList().then(
                    categorySelectionList => {

                        CityAndStateService.getStateList().then(
                            stateList => {

                                const tempList = categorySelectionList.data.data.data;
                                this.setState({
                                    locationList: ArrayValueReorder(list.data.data, "title"),
                                    categoryList: tempList,
                                    pageLoading: false,
                                    stateList: stateList.data.data
                                });

                            }
                        ).catch(error => {
                            this.setState({
                                pageLoading: false,
                            });
                        });
                    }
                ).catch(error => {
                    this.setState({
                        pageLoading: false,
                    });
                });
            }
        ).catch(error => {
            this.setState({
                pageLoading: false,
            });
        });
    }

    getPreviousValues = () => {
        const check = this.props.previousPath.component === "ItemsForAdvanceSearch";
        if (check) {
            let temp = getMaintainData(advanceSearchMain);
            temp = {
                ...temp,
                searchForm: {
                    ...temp.searchForm,
                    endDate: {
                        ...temp.searchForm.endDate,
                        value: temp.searchForm.endDate.value ? new Date(temp.searchForm.endDate.value) : ''
                    },
                    startDate: {
                        ...temp.searchForm.startDate,
                        value: temp.searchForm.startDate.value ? new Date(temp.searchForm.startDate.value) : ''
                    }
                }
            };
            this.setState({
                ...this.state,
                ...temp,
                restrictedItems: CATERGORY.includes(temp.activeSubMenuValue) ? true : false,
                pageLoading: false,
            }, () => {
                disablePreviousState();
            });
        } else {
            this.getRequiredData();
        }
    }

    isDisabledLink = (flag) => {
        const list = ['Collectibles', 'Craft & Hobby', 'Electronics', 'Jewlery', 'Motor Vechicles']
        return list.includes(flag);
    }

    /* checks whether the input is valid or not */
    onInputValidation = (event, formName) => {
        let controlError = '';
        let value = null;

        /* checks all the validators for the control */
        for (let validator of this.state[formName][event.target.name].validators) {
            controlError = validator(event.target.value);
            if (controlError) break;
        }
        value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        /* sets the state of the control and form validity */
        this.setState({
            [formName]: {
                ...this.state[formName],
                [event.target.name]: {
                    ...this.state[formName][event.target.name],
                    value: value,
                    valid: !Boolean(controlError),
                    error: controlError
                }
            }
        },
            () => {
                /* check form validity */
                if (controlError)
                    this.setState({ formValid: false });
                else {
                    let formValid = true;
                    for (let control of Object.keys(this.state[formName])) {
                        if (!this.state[formName][control].valid) {
                            formValid = false;
                            break;
                        }
                    }
                    this.setState({ formValid: formValid });
                }
            });
    }

    /* set date for date input change */
    setDate = (control, date, clearControl = null) => {
        this.setState({
            ...this.state,
            searchForm: {
                ...this.state.searchForm,
                [control]: {
                    ...this.state.searchForm[control],
                    value: date
                },
                [clearControl]: {
                    ...this.state.searchForm[clearControl],
                    value: null
                }
            }
        }, () => {
            if (clearControl) {
                this.setState({
                    ...this.state,
                    searchForm: {
                        ...this.state.searchForm,
                        [clearControl]: {
                            ...this.state.searchForm[clearControl],
                            value: null
                        }
                    }
                });
            }
        });
    }

    handleDateChangeRaw = (e) => {
        // e.preventDefault();
    }

    /* Called when click window */
    handleClickOutside = (e) => {
        if (this.sideNavbar && this.sideNavbar.contains(e.target)) {
            // the click happened in the component
            return;
        }

        // click happened outside the component
        // hide the sidebar
        const class_list = e.target.classList ? [...e.target.classList] : [];
        if (!class_list.includes('fa-bars') && !class_list.includes('catrgory-input')) {
            if (this.props.customSidebar.icon) {
                store.dispatch({ type: 'SET_CUSTOM_SIDEBAR', payload: { icon: true, open: false } });
            }
        }
    }

    setCategory = (flag, makeNull = false, fromMenu) => {
        this.closeSideBar();
        if (flag) {
            this.setState({
                activeSubMenuValue: flag,
                activeSubMenuStatus: true,
                restrictedItems: CATERGORY.includes(flag) ? true : false
            })
        }
        if (!fromMenu) {
            this.setState({
                activeMenuStatus: false
            })
        }

        let controlError = "";

        const check = this.state.activeMenu;

        /* checks all the validators for the control */
        for (let validator of this.state.searchForm.category.validators) {
            controlError = validator(flag);
            if (controlError) break;
        }

        /* sets the state of the control and form validity */
        this.setState({
            searchForm: {
                ...this.state.searchForm,
                category: {
                    ...this.state.searchForm.category,
                    value: flag,
                    valid: !Boolean(controlError),
                    error: controlError
                }
            },
            activeMenu: makeNull ? '' : check
        },
            () => {
                /* check form validity */
                if (controlError)
                    this.setState({ formValid: false });
                else {
                    let formValid = true;
                    for (let control of Object.keys(this.state.searchForm)) {
                        if (!this.state.searchForm[control].valid) {
                            formValid = false;
                            break;
                        }
                    }
                    this.setState({ formValid: formValid });
                }
            });
        let dataLayerData = {
            'event': 'category',
            'title': flag
        }
        addDataLayer(dataLayerData);    
    }


    selectMenu = (flag) => {
        this.closeSideBar();
        if (flag) {
            this.setState({
                activeMenuStatus: true,
                activeMenuValue: flag
            })
        }
        // const check = this.state.activeMenu === flag;
        const value = flag;
        this.setState({
            activeMenu: value,
        }, () => {
            this.setCategory(value, false, true)
        })
    }

    closeSideBar = () => {
        if (window.innerWidth < 1100) {
            store.dispatch({ type: 'SET_CUSTOM_SIDEBAR', payload: { icon: true, open: false } });
        }
    }

    resetForm = (event) => {
        event.preventDefault();
        this.setState({
            searchForm: Object.assign({}, this.searchForm),
            activeMenu: 'ALL',
            activeMenuStatus: false,
            activeMenuValue: '',
            activeSubMenuStatus: false,
            activeSubMenuValue: '',
            restrictedItems: false,
        });
        this.buttonDOM.blur();
    }

    submit = () => {
        const filter = [];
        const data = {};
        const sort = [{ "field": "title", "direction": "asc" }];
        const temp_data = this.state.searchForm;
        Object.keys(temp_data).forEach(key => {
            if (temp_data[key].value) {
                data[key] = temp_data[key].value;
                switch (key) {
                    case "location":
                        if (temp_data[key].value !== 'All') {
                            const location = this.state.locationList.filter(x => x.title === temp_data[key].value);
                            filter.push({ "field": "locationid", "value": location[0].id, "op": "=", "join": "AND" });
                        }
                        break;
                    case "category":
                        if (temp_data[key].value !== 'All Categories') {
                            if (this.state.activeMenuStatus) {
                                filter.push({ "field": "categoryGroup", "value": temp_data[key].value, "op": "=", "join": "AND" });
                            } else {
                                if (this.state.activeMenu) {
                                    filter.push({ "field": "categoryGroup", "value": this.state.activeMenu, "op": "=", "join": "AND" });
                                }
                                filter.push({ "field": "category", "value": temp_data[key].value, "op": "=", "join": "AND" });
                            }
                        }
                        break;
                    case "keywords":
                        filter.push({ "field": "title", "value": `%${temp_data[key].value}%`, "op": "LIKE", "join": "OR" });
                        filter.push({ "field": "tag", "value": `%${temp_data[key].value}%`, "op": "LIKE", "join": "OR" });
                        filter.push({ "field": "description", "value": `%${temp_data[key].value}%`, "op": "LIKE", "join": "AND" });
                        break;
                    case "zipcode":
                        filter.push({ "field": "zipcode", "value": temp_data[key].value, "op": "=", "join": "AND" });
                        break;
                    case "state":
                        filter.push({ "field": "state", "value": temp_data[key].value, "op": "=", "join": "AND" });
                        break;
                    case "country":
                        filter.push({ "field": "country", "value": temp_data[key].value, "op": "=", "join": "AND" });
                        break;
                    case "pricemin":
                        filter.push({ "field": "bidprice", "value": temp_data[key].value, "op": ">=", "join": "AND" });
                        break;
                    case "pricemax":
                        filter.push({ "field": "bidprice", "value": temp_data[key].value, "op": "<=", "join": "AND" });
                        break;
                    case "startDate":
                        const startDate = moment(temp_data[key].value).startOf('day').utc();
                        filter.push({ "field": "itemclosetime", "value": startDate.format("YYYY-MM-DD HH:mm:ss"), "op": ">=", "join": "AND" });
                        data[key] = startDate.format('MM/DD/YYYY');
                        break;
                    case "endDate":
                        const endDate = moment(temp_data[key].value).endOf('day').utc();
                        filter.push({ "field": "itemclosetime", "value": endDate.format('YYYY-MM-DD HH:mm:ss'), "op": "<=", "join": "AND" });
                        data[key] = endDate.format('MM/DD/YYYY');
                        break;
                    case "auction":
                        filter.push({ "field": "itemtypeid", "value": 2, "op": "=", "join": "AND" });
                        break;
                    case "directBuy":
                        filter.push({ "field": "itemtypeid", "value": 1, "op": "=", "join": "AND" });
                        break;
                    case "onSite":
                        filter.push({ "field": "itemtypeid", "value": 3, "op": "=", "join": "AND" });
                        break;
                    case "completed":
                        filter.push({
                            "field": "itemstatus",
                            "value": "Not Sold",
                            "op": "=",
                            "join": "OR"
                        });
                        filter.push({
                            "field": "itemstatus",
                            "value": "Sold",
                            "op": "=",
                            "join": "OR"
                        });
                        break;
                    case "include":
                        filter.push({ "field": "itemstatus", "value": "Sold", "op": "=", "join": "AND" });
                        break;
                    case "buynow":
                        filter.push({ "field": "buynowprice", "value": 0, "op": ">", "join": "AND" });
                        break;
                    case "noreserve":
                        filter.push({ "field": "reserveprice", "value": 0, "op": "<=", "join": "AND" });
                        break;
                    case "sortBy":
                        const getList = temp_data[key].value.split('#*#');
                        // filter.push({ "field": "sortby", "value": getList[2], "op": "=", "join": "AND" });
                        sort[0] = { "field": getList[0], "direction": getList[1] };
                        break;
                    case "miles":
                        filter.push({ "field": "miles", "value": temp_data[key].value, "op": "=", "join": "AND" });
                        break;
                   // case "isshippable":
                     //   filter.push({ "field": "isshippable", "value": 1, "op": "=", "join": "OR" });
                    //    break; 
                   // case "pickuponly":
                    //    filter.push({ "field": "isshippable", "value": 0, "op": "=", "join": "AND" });
                     //   break;         
                    default:
                        console.error("Out of range");
                        break;
                }
            }
        });
        if (Object.keys(data).includes('isshippable') && Object.keys(data).includes('pickuponly')) {
            filter.push({ "field": "isshippable", "value": 1, "op": "=", "join": "OR" });
            filter.push({ "field": "isshippable", "value": 0, "op": "=", "join": "AND" });
        }else if (Object.keys(data).includes('isshippable')) {
            filter.push({ "field": "isshippable", "value": 1, "op": "=", "join": "AND" });
          
        }else if (Object.keys(data).includes('pickuponly')) {
           filter.push({ "field": "isshippable", "value": 0, "op": "=", "join": "AND" });
        };
        // filter.push({ "field": "itemstatus", "value": "Ready", "op": "=", "join": "AND" });
        if (!Object.keys(data).includes('completed')) {
            filter.push({ "field": "salestatus", "value": "Started", "op": "=", "join": "AND" });
            filter.push({ "field": "itemstatus", "value": "Ready", "op": "=", "join": "AND" })
        };
        const paramsData = { data, filter: { filter }, sort };
        // const final = btoa(JSON.stringify(paramsData));
        const storeData = {
            locationList: this.state.locationList,
            categoryList: this.state.categoryList,
            stateList: this.state.stateList,
            cityList: this.state.cityList,
            searchForm: this.state.searchForm,
            activeMenu: this.state.activeMenu,
            activeMenuStatus: this.state.activeMenuStatus,
            activeMenuValue: this.state.activeMenuValue,
            activeSubMenuStatus: this.state.activeSubMenuStatus,
            activeSubMenuValue: this.state.activeSubMenuValue
        };
        convertToMaintainData(advanceSearchMain, storeData);
        this.props.history.push(`/advance-search/items`, {advancedSearchFilter: paramsData });
    }

    openSideBar = (event) => {
        if (window.innerWidth < 1100) {
            store.dispatch({ type: 'SET_CUSTOM_SIDEBAR', payload: { icon: true, open: !this.props.customSidebar.open } });
        }
    }

    componentWillUnmount() {
        store.dispatch({ type: 'SET_CUSTOM_SIDEBAR', payload: { icon: false, open: false } });
        window.removeEventListener('resize', this.windowWidthGet);
        window.removeEventListener('click', this.handleClickOutside);

        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    render() {
        return (
            <div className="advance-search">
                <Helmet>
                    <title>CTBids | Search</title>
                </Helmet>
                {
                    this.state.pageLoading ? <div className="loader d-flex align-items-center justify-content-center">
                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                    </div> : <div className="d-flex main-container">
                        <div className={`sidenav ${this.state.innerWidth < 992 ? 'mobile-sidenav' : ''} ${this.props.customSidebar.icon ? this.props.customSidebar.open ? '' : 'd-none' : this.state.innerWidth < 992 ? this.props.customSidebar.open ? '' : 'd-none' : ''}`}
                            ref={node => this.sideNavbar = node} style={this.state.innerWidth < 992 ? { paddingBottom: `${this.state.sideBarScrollHeight}px` } : {}}>
                            <div className="sticky-sidebar">
                                <div className="h5 top-text">Search By Categories</div>
                                <div className={`all-link clickable ${this.state.searchForm.category.value === "All Categories" ? 'menu-item-active' : ''}`} onClick={() => this.setCategory('All Categories')}>All</div>
                                <div className="nav-links-handle">
                                    <ul className="d-flex flex-column menu-list">
                                        {
                                            this.state.categoryList.map((menu, i) => {
                                                return (
                                                    menu?.selection.length > 1 ? <li key={`links_${i}`}>
                                                        <div className={`d-flex flex-column ${this.state.activeMenu === menu.category ? 'active-item' : ''}`}>
                                                            <div className="clickable" onClick={() => this.selectMenu(menu.category)}>
                                                                <div className={`d-flex flex-row menu-item ${this.state.activeMenuStatus && this.state.activeMenuValue === menu.category ? 'menu-item-active' : ''} ${1 === 0 ? 'disabled' : ''}`}>
                                                                    <div className="d-flex flex-row align-items-center justify-content-between menu-item-name">
                                                                        <div className="d-flex"><span className="expand-handle"></span>&ensp;<div aria-label={'clicking ' + `${menu.category}`}>{menu.category}</div></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex flex-column align-items-center justify-content-center sub-menu">
                                                                {
                                                                    menu.selection.map((sub_menu, j) => {
                                                                        return (
                                                                            <div className={`sub-menu-item clickable ${this.state.activeSubMenuStatus && this.state.activeSubMenuValue === sub_menu.subcategory ? 'sub-menu-active' : ''}`} onClick={() => this.setCategory(sub_menu.subcategory)} key={`sub_links${j}`}>
                                                                                <div className={`d-flex flex-row`}>
                                                                                    <div className="d-flex flex-column align-items-start justify-content-end sub-menu-item-name">
                                                                                        <div className="d-flex"><span></span>&ensp;<div aria-label={'clicking ' + `${sub_menu.subcategory}`}>{sub_menu.subcategory}</div></div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    </li> : <li key={`links_${i}`} onClick={() => this.selectMenu(menu.category)}>
                                                        <div className={`d-flex flex-column ${menu?.count === 0 ? 'disabled' : ''} ${!this.state.activeMenuStatus && this.state.searchForm.category.value === menu.category ? 'menu-item-active' : ''}`}>
                                                            <div>
                                                                <div className="d-flex flex-row menu-item">
                                                                    <div className="d-flex flex-column align-items-start justify-content-center menu-item-name">
                                                                        <div className="d-flex"><span></span>&ensp;<div>{menu.category}</div></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="content-container w-100">
                            {!this.props.user.membershipCompleted ?
                            <div className='w-100' style={{ justifyContent: 'center', alignItems:' center', display: 'flex',  }}>
                                {bannerImage(this.props, 'Premier-BannerAd-Search-Unlock3')}
                            </div> : ''}
                            <div className="page-title h5">
                                Advanced search
                            </div>
                            <div className="form">
                                <Form>
                                    <Form.Group controlId="searchon">
                                        <Form.Label>Search on</Form.Label>
                                        <Form.Control as="select" name="location" value={this.state.searchForm.location.value} onChange={(event) => { this.onInputValidation(event, 'searchForm') }}>
                                            <option value="All">All Locations</option>
                                            {
                                                this.state.locationList.map(location =>
                                                    <option value={location.title} key={location.title}>{location.title}</option>
                                                )
                                            }
                                        </Form.Control>
                                    </Form.Group>
                                    <Form.Group controlId="category" className="category-field">
                                        {this.state.innerWidth < 1100 ? null : <div className="arrow"></div>}
                                        <Form.Label>Category</Form.Label>
                                        <Form.Control placeholder="All Categories" name="category" className="catrgory-input" value={this.state.searchForm.category.value}
                                            onChange={(event) => { this.onInputValidation(event, 'searchForm') }} onClick={this.openSideBar} readOnly />
                                    </Form.Group>
                                    <div className="d-lg-flex align-items-center ">
                                        <Form.Group controlId="keywords">
                                            <Form.Label>Keywords</Form.Label>
                                            <Form.Control placeholder="Search all of these words" name="keywords" value={this.state.searchForm.keywords.value} onChange={(event) => { this.onInputValidation(event, 'searchForm') }} />
                                        </Form.Group>
                                        {/* <Form.Group controlId="include-checkbox" className="include-checkbox">
                                            <Form.Check custom type="checkbox" label="Include Description" name="includeDescription" onChange={(event) => { this.onInputValidation(event, 'searchForm') }} />
                                        </Form.Group> */}
                                    </div>
                                    <div className="d-lg-flex align-items-center location-section">
                                        <Form.Group controlId="zipcode">
                                            <Form.Label>Item Location</Form.Label>
                                            <Form.Control placeholder="Zip Code" type="number" name="zipcode" value={this.state.searchForm.zipcode.value} onChange={(event) => { this.onInputValidation(event, 'searchForm') }} />
                                        </Form.Group>
                                        <Form.Group controlId="state">
                                            <Form.Label>State</Form.Label>
                                            <Form.Control placeholder="State" as="select" name="state" className={`${this.state.searchForm.state.value ? '' : 'text-muted text-normal'}`} value={this.state.searchForm.state.value} onChange={(event) => { this.onInputValidation(event, 'searchForm') }}>
                                                <option value={null} className="d-none">Select State</option>
                                                {
                                                    this.state.stateList.map(state => <option value={state.state} key={state.state}>{state.state}</option>)
                                                }
                                            </Form.Control>
                                        </Form.Group>
                                        {/* <Form.Group controlId="country">
                                            <Form.Label className="invisible">Country</Form.Label>
                                            <Form.Control placeholder="Country" as="select" name="country" className={`${this.state.searchForm.country.value ? '' : 'text-muted text-normal'}`} value={this.state.searchForm.country.value} onChange={(event) => { this.onInputValidation(event, 'searchForm') }}>
                                                <option value={null} className="d-none">Select Country</option>
                                                <option value="USA">USA</option>
                                            </Form.Control>
                                        </Form.Group> */}
                                        <Form.Group controlId="miles">
                                            <Form.Label>Miles</Form.Label>
                                            <Form.Control placeholder="Miles" as="select" name="miles" className={`${this.state.searchForm.miles.value ? '' : 'text-muted text-normal'}`} value={this.state.searchForm.miles.value} onChange={(event) => { this.onInputValidation(event, 'searchForm') }}>
                                                <option value={null} className="d-none">Select Miles</option>
                                                <option>5</option>
                                                <option>10</option>
                                                <option>25</option>
                                                <option>50</option>
                                                <option>100</option>
                                                <option>250</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </div>
                                    <div className="d-lg-flex align-items-center price-range">
                                        <Form.Group>
                                            <Form.Label htmlFor="price-range-from">
                                                Price Range From
                                            </Form.Label>
                                            <InputGroup className="mb-2">
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text>$</InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <FormControl id="price-range-from" type="number" placeholder="min" name="pricemin" value={this.state.searchForm.pricemin.value} onChange={(event) => { this.onInputValidation(event, 'searchForm') }} />
                                            </InputGroup>
                                        </Form.Group>
                                        <div className="d-none d-lg-block middle">
                                            &#8722;
                                        </div>
                                        <Form.Group>
                                            <Form.Label htmlFor="price-range-to" className="invisible">
                                                Price Range From
                                            </Form.Label>
                                            <InputGroup className="mb-2">
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text>$</InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <FormControl id="price-range-to" type="number" placeholder="max" name="pricemax" value={this.state.searchForm.pricemax.value} onChange={(event) => { this.onInputValidation(event, 'searchForm') }} />
                                            </InputGroup>
                                        </Form.Group>
                                    </div>
                                    <div className="d-md-flex">
                                        <div className="datetime-section">
                                            <Form.Label>
                                                Date From
                                            </Form.Label>
                                            <label aria-label='Start date' onClick={e => this.startDate.state.open && e.preventDefault()}>
                                                <DatePicker ref={r => this.startDate = r} className="form-control" dateFormat="MM/dd/yyyy" value={this.state.searchForm.startDate.value} label="start date" selected={this.state.searchForm.startDate.value} onChange={date => { this.setDate('startDate', date, 'endDate') }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="Start Date (MM/DD/YYYY)" dropdownMode="select" />
                                                <i className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                        <div className="datetime-section">
                                            <Form.Label className="invisible">
                                                End Date
                                            </Form.Label>
                                            <label aria-label='End date' onClick={e => this.endDate.state.open && e.preventDefault()}>
                                                <DatePicker ref={r => this.endDate = r} className="form-control" dateFormat="MM/dd/yyyy" value={this.state.searchForm.endDate.value} label="end date" selected={this.state.searchForm.endDate.value} onChange={date => { this.setDate('endDate', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="End Date (MM/DD/YYYY)" dropdownMode="select"
                                                    minDate={moment(this.state.searchForm.startDate.value).add(1, 'days').toDate()} />
                                                <i className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </div>
                                    <div>
                                        <Form.Label>
                                            Search Only
                                        </Form.Label>
                                        <div className="d-md-flex">
                                            <Form.Group className="multiple-checkbox">
                                                <Form.Check custom type="checkbox" id="auction" name="auction" label="Auction" checked={JSON.parse(this.state.searchForm.auction.value)} onChange={(event) => { this.onInputValidation(event, 'searchForm') }} />
                                            </Form.Group>
                                            <Form.Group className="multiple-checkbox">
                                                <Form.Check custom type="checkbox" id="directbuy" name="directBuy" label="Direct buy" checked={this.state.restrictedItems ? false : JSON.parse(this.state.searchForm.directBuy.value)} disabled={this.state.restrictedItems} onChange={(event) => { this.onInputValidation(event, 'searchForm') }} />
                                            </Form.Group>
                                            <Form.Group className="multiple-checkbox">
                                                <Form.Check custom type="checkbox" id="onSite" name="onSite" label="On Site Only" checked={JSON.parse(this.state.searchForm.onSite.value)} onChange={(event) => { this.onInputValidation(event, 'searchForm') }} />
                                            </Form.Group>
                                            <Form.Group className="multiple-checkbox">
                                                <Form.Check custom type="checkbox" id="buy-now" name="buynow" label="Buy Now" checked={this.state.restrictedItems ? false : JSON.parse(this.state.searchForm.buynow.value)} disabled={this.state.restrictedItems} onChange={(event) => { this.onInputValidation(event, 'searchForm') }} />
                                            </Form.Group>
                                            <Form.Group className="multiple-checkbox">
                                                <Form.Check custom type="checkbox" id="isshippable" name="isshippable" label="Shippable" checked={JSON.parse(this.state.searchForm.isshippable.value)} onChange={(event) => { this.onInputValidation(event, 'searchForm') }} />
                                            </Form.Group>
                                            <Form.Group className="multiple-checkbox">
                                                <Form.Check custom type="checkbox" id="pickuponly" name="pickuponly" label="Pick Up Only" checked={JSON.parse(this.state.searchForm.pickuponly.value)} onChange={(event) => { this.onInputValidation(event, 'searchForm') }} />
                                            </Form.Group>
                                            {/* <Form.Group className="multiple-checkbox">
                                                <Form.Check custom type="checkbox" id="completed" name="completed" label="Include Closed Items" checked={JSON.parse(this.state.searchForm.completed.value)} onChange={(event) => { this.onInputValidation(event, 'searchForm') }} />
                                            </Form.Group> */}
                                            {/* <Form.Group className="multiple-checkbox">
                                                <Form.Check custom type="checkbox" id="sold" name="include" label="Include Sold Items" onChange={(event) => { this.onInputValidation(event, 'searchForm') }} />
                                            </Form.Group> */}
                                        </div>
                                        <div className="d-md-flex">
                                            <Form.Group className="multiple-checkbox w-unset">
                                                <Form.Check custom type="checkbox" id="completed" name="completed" className="w-100" label="Completed (Location or Category selection is required)" checked={JSON.parse(this.state.searchForm.completed.value)} onChange={(event) => { this.onInputValidation(event, 'searchForm') }} />
                                            </Form.Group>
                                            {/* <Form.Group className="multiple-checkbox">
                                                <Form.Check custom type="checkbox" id="buy-now" name="buynow" label="Buy Now" checked={JSON.parse(this.state.searchForm.buynow.value)} onChange={(event) => { this.onInputValidation(event, 'searchForm') }} />
                                            </Form.Group>
                                            <Form.Group className="multiple-checkbox">
                                                <Form.Check custom type="checkbox" id="no-reserve" name="noreserve" label="No Reserve" checked={JSON.parse(this.state.searchForm.noreserve.value)} onChange={(event) => { this.onInputValidation(event, 'searchForm') }} />
                                            </Form.Group> */}
                                        </div>
                                    </div>
                                    <div className="d-lg-flex sort-and-page pb-10">
                                        <Form.Group controlId="sort-by">
                                            <Form.Label>Sort by</Form.Label>
                                            <Form.Control placeholder="Sort by" as="select" name="sortBy" value={this.state.searchForm.sortBy.value} onChange={(event) => { this.onInputValidation(event, 'searchForm') }}>
                                                <option value="itemclosetime#*#asc#*#Listing Ending First">Listing Ending First</option>
                                                <option value="itemclosetime#*#desc#*#Listing Ending Last">Listing Ending Last</option>
                                                <option value="itemlistingtime#*#desc#*#Newest Listing First">Newest Listing First</option>
                                                <option value="itemlistingtime#*#asc#*#Oldest Listing First">Oldest Listing First</option>
                                                <option value="title#*#asc#*#Alphanumeric by Title First">Alphanumeric by Title First</option>
                                                <option value="title#*#desc#*#Alphanumeric by Title Last">Alphanumeric by Title Last</option>
                                                <option value="bidprice#*#asc#*#Price Low-High">Price Low-High</option>
                                                <option value="bidprice#*#desc#*#Price High-Low">Price High-Low</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </div>
                                    <div className="buttons mb-3 d-flex align-items-center">
                                        <Button variant="outline-primary" onClick={this.resetForm} ref={(buttonDOM) => { this.buttonDOM = buttonDOM; }}>Reset</Button>
                                        <Button variant="" className='ctbids-btn' aria-label='click search' onClick={this.submit} disabled={(this.state.searchForm.category.value === "All Categories" && this.state.searchForm.location.value === "All") && JSON.parse(this.state.searchForm.completed.value)}>
                                            Search
                                        </Button>
                                        {
                                            (this.state.searchForm.category.value === "All Categories" && this.state.searchForm.location.value === "All") && JSON.parse(this.state.searchForm.completed.value) ?
                                                <div className="text-danger">Location or category is required</div> : null
                                        }
                                    </div>
                                </Form>

                            </div>
                               
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default connect(state => state)(AdvanceSearch);